"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useWidgetScroll", {
    enumerable: true,
    get: function() {
        return useWidgetScroll;
    }
});
const _react = require("react");
const useWidgetScroll = ()=>{
    const gridRef = (0, _react.useRef)(null);
    const [scrollWidth, setScrollWidth] = (0, _react.useState)(0);
    const [gridWidth, setGridWidth] = (0, _react.useState)(0);
    const [scrollLeft, setScrollLeft] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        var _gridRef_current;
        const resizeObserver = new ResizeObserver(()=>{
            var _gridRef_current_parentElement, _gridRef_current, _gridRef_current_parentElement1, _gridRef_current1;
            var _gridRef_current_parentElement_clientWidth;
            setGridWidth((_gridRef_current_parentElement_clientWidth = (_gridRef_current = gridRef.current) === null || _gridRef_current === void 0 ? void 0 : (_gridRef_current_parentElement = _gridRef_current.parentElement) === null || _gridRef_current_parentElement === void 0 ? void 0 : _gridRef_current_parentElement.clientWidth) !== null && _gridRef_current_parentElement_clientWidth !== void 0 ? _gridRef_current_parentElement_clientWidth : 0);
            var _gridRef_current_parentElement_scrollWidth;
            setScrollWidth((_gridRef_current_parentElement_scrollWidth = (_gridRef_current1 = gridRef.current) === null || _gridRef_current1 === void 0 ? void 0 : (_gridRef_current_parentElement1 = _gridRef_current1.parentElement) === null || _gridRef_current_parentElement1 === void 0 ? void 0 : _gridRef_current_parentElement1.scrollWidth) !== null && _gridRef_current_parentElement_scrollWidth !== void 0 ? _gridRef_current_parentElement_scrollWidth : 0);
        });
        const scrollHandler = ()=>{
            var _gridRef_current_parentElement, _gridRef_current;
            var _gridRef_current_parentElement_scrollLeft;
            setScrollLeft((_gridRef_current_parentElement_scrollLeft = (_gridRef_current = gridRef.current) === null || _gridRef_current === void 0 ? void 0 : (_gridRef_current_parentElement = _gridRef_current.parentElement) === null || _gridRef_current_parentElement === void 0 ? void 0 : _gridRef_current_parentElement.scrollLeft) !== null && _gridRef_current_parentElement_scrollLeft !== void 0 ? _gridRef_current_parentElement_scrollLeft : 0);
        };
        if (((_gridRef_current = gridRef.current) === null || _gridRef_current === void 0 ? void 0 : _gridRef_current.parentElement) != null) {
            resizeObserver.observe(gridRef.current);
            gridRef.current.parentElement.addEventListener("scroll", scrollHandler);
        }
        return ()=>{
            if (gridRef.current != null) {
                var _gridRef_current_parentElement;
                resizeObserver.unobserve(gridRef.current);
                (_gridRef_current_parentElement = gridRef.current.parentElement) === null || _gridRef_current_parentElement === void 0 ? void 0 : _gridRef_current_parentElement.removeEventListener("scroll", scrollHandler);
            }
        };
    }, []);
    const scrollWidget = (direction)=>{
        const grid = gridRef.current;
        if (grid != null) {
            var _gridRef_current_parentElement, _gridRef_current, _grid_parentElement;
            var _gridRef_current_parentElement_scrollLeft;
            const currentOffset = (_gridRef_current_parentElement_scrollLeft = (_gridRef_current = gridRef.current) === null || _gridRef_current === void 0 ? void 0 : (_gridRef_current_parentElement = _gridRef_current.parentElement) === null || _gridRef_current_parentElement === void 0 ? void 0 : _gridRef_current_parentElement.scrollLeft) !== null && _gridRef_current_parentElement_scrollLeft !== void 0 ? _gridRef_current_parentElement_scrollLeft : 0;
            const indexDirection = direction === "left" ? -1 : 1;
            const index = Math.floor(currentOffset / grid.children[0].clientWidth) + indexDirection;
            const gap = 8;
            (_grid_parentElement = grid.parentElement) === null || _grid_parentElement === void 0 ? void 0 : _grid_parentElement.scrollTo({
                left: index * grid.children[0].clientWidth + index * gap,
                behavior: "smooth"
            });
        }
    };
    const isLeftScrollPossible = scrollLeft > 0;
    const isRightScrollPossible = scrollLeft < scrollWidth - gridWidth;
    return {
        gridRef,
        scrollWidget,
        isLeftScrollPossible,
        isRightScrollPossible
    };
};

//# sourceMappingURL=useWidgetScroll.js.map